import { render } from "./SMS_Integrations.vue?vue&type=template&id=72d26b8a"
import script from "./SMS_Integrations.vue?vue&type=script&lang=js"
export * from "./SMS_Integrations.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__